export default __webpack_public_path__ + "static/media/Sarabun-Regular.e4a771fc.ttf";